import React, { memo } from "react";

import ModalSection from "@hl/base-components/lib/modal/ModalSection";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { Button, Group, Modal, Text } from "@mantine/core";

import { BlockchainEntity } from "components/BlockchainEntityTitle/types";
import { useArchiveDraft } from "~/features/collections/sections/ContractCollectionDashboard/menu/draftArchiveHook";

const DraftArchiveModal = ({
  entity,
  isOpened,
  onClose,
}: {
  entity: BlockchainEntity;
  isOpened: boolean;
  onClose: () => void;
}) => {
  const { toggleArchive, loading } = useArchiveDraft({
    entity,
    onSuccess: onClose,
  });

  return (
    <Modal
      opened={isOpened}
      onClose={onClose}
      size="lg"
      title="Archive collection"
    >
      <Text size="sm">
        Archiving this collection will move it to your archive. To reverse this
        action, unarchive the collection.
      </Text>
      <ModalSection>
        <Group spacing={16} grow>
          <Button size="lg" color={SECONDARY_COLOR} onClick={onClose}>
            Cancel
          </Button>
          <Button size="lg" loading={loading} onClick={toggleArchive}>
            Archive
          </Button>
        </Group>
      </ModalSection>
    </Modal>
  );
};

export default memo(DraftArchiveModal);
